<portal v-if="portalCreated"
        :target-el="portalTargetSelector"
        open-trigger="manual">
    <transition name="m--is">
        <div v-show="portalMounted && propOpen"
             class="m-toast"
             :class="{'m--is-state-confirmation': isStateConfirmation,
                    'm--is-state-information': isStateInformation,
                    'm--is-state-warning': isStateWarning,
                    'm--is-state-error': isStateError,
                    'm--is-top': isTop,
                    'm--is-bottom': !isTop,
                    'm--is-left': isLeft,
                    'm--is-center': isCenter,
                    'm--is-right': isRight,
                    'm--is-mobile': isMqMaxS,
                    'm--is-desktop': !isMqMaxS }"
             @mouseover="mouseEnterToast"
             @mouseleave="mouseLeaveToast"
             ref="toast">
            <div role="alert" class="m-toast__sreen-reader-only">
                <template v-if="showScreenReaderText">
                    {{ i18nTypeMessage }} <slot></slot>
                    <m-link v-if="actionLabel" :mode="buttonMode"
                            @click="onAction">{{ actionLabel }}</m-link>
                </template>
            </div>
            <div class="m-toast__wrap">
                <div v-if="icon"
                     class="m-toast__icon">
                    <m-svg :name="getIcon()"
                            width="1em"
                            height="1em" />
                </div>
                <div class="m-toast__body" aria-hidden="true">
                    <div class="m-toast__text">
                        <slot></slot>
                    </div>
                    <div v-if="actionLabel"
                         class="m-toast__actions">
                        <m-link :mode="buttonMode"
                                @click="onAction">{{ actionLabel }}</m-link>
                    </div>
                </div>
                <m-icon-button class="m-toast__close-button"
                               v-if="closeButton"
                               :title="$i18n.translate('m-toast:close')"
                               :skin="closeButtonSkin"
                               :icon-name="closeButtonIconeName"
                               icon-size="12px"
                               ref="toastclose"
                               @click="onClose" />
            </div>
        </div>
    </transition>
</portal>
